import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

import { FinancialAccount } from '@/reducers/finances/financialAccountsReducer'
import { useAnalyticsTrack } from '@/features/amplitude'
import { Button, Icon } from '@/ui'

export const AwaitingConfirmationButton = ({
  account,
  disconnectedOn,
  setAccountToEdit,
  setInitialStateModalOpen,
}: {
  account: FinancialAccount
  disconnectedOn?: string
  setAccountToEdit: (value: FinancialAccount | null) => void
  setInitialStateModalOpen: (value: boolean) => void
}) => {
  const track = useAnalyticsTrack()

  return (
    <>
      <Icon
        color={'orange'}
        icon={solid('triangle-exclamation')}
        className="ml-2"
      />

      <Button
        variant="secondary"
        disabled={Boolean(disconnectedOn)}
        className="ml-2"
        onClick={() => {
          setAccountToEdit(account)
          setInitialStateModalOpen(true)
          track('clicked review bank account button')
        }}
        size="sm"
      >
        Awaiting your confirmation
      </Button>
    </>
  )
}
